import { UserState } from "../../type/user-state";

export const clearSelectedUserDispatch = (state: UserState) => {
  state.selectedUser = undefined;
};
